import { fetchOrders, fetchOrderByPuDate} from './apiService';
    
        export const getOrders = async (orderNumber) => {
          try {
            const response = await fetchOrders(orderNumber);
            return response;
          } catch (error) {
            return error;
            // Handle error...
          }
        };
    
        export const getOrderByPuDate = async (orderNumber, puDate) => {
          try {
            const response = await fetchOrderByPuDate(orderNumber, puDate);
            return response;
          } catch (error) {
            return error;
          }
        };

        // Other data layer methods...